import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { createDynamicStyle } from 'cms/helpers/styledComponents'

const EmptyTextEditor = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20;
  font-weight: 700;
  border: 2px solid #a5a5a5;
  background-color: #f5f5f5;
`

const CmsTextEditor = styled(
  ({
    html,
    style,
    className,
  }) => {
    if (!html) {
      return (
        <EmptyTextEditor>
          โปรดใส่ข้อความ
        </EmptyTextEditor>
      )
    }
    return (
      <div
        style={style}
        className={className}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )
  }
)`
  ${({ theme }) => ({
    ...createDynamicStyle(theme, 'cms', 'textEditor')(),
  })}
`

CmsTextEditor.propTypes = {
  html: PropTypes.string.isRequired,
  style: PropTypes.object,
}
CmsTextEditor.defaultProps = {
  style: {},
}

export default CmsTextEditor



// WEBPACK FOOTER //
// ./src/cms/CmsTextEditor.js